export function createQueryParams(params:any) {
    const urlSearchParams = new URLSearchParams(params);
    return urlSearchParams.toString();
}